import { useMemo } from 'react';
import { useLocale } from './useLocale';
var formatterCache = new Map();
export function useDateFormatter(options) {
    var locale = useLocale().locale;
    var cacheKey = useMemo(function () { return getCacheKey(locale, options); }, [locale, options]);
    var cacheValue = formatterCache.get(cacheKey);
    if (cacheValue) {
        return cacheValue;
    }
    var formatter = new Intl.DateTimeFormat(locale, options);
    formatterCache.set(cacheKey, formatter);
    return formatter;
}
function getCacheKey(locale, options) {
    var salt = '';
    if (options !== undefined) {
        salt = Object.keys(options)
            .map(function (key) { return [key, options[key]]; })
            .sort(function (a, b) { return (a[0] < b[0] ? -1 : 1); })
            .join();
    }
    return locale + salt;
}
